export const storeKey = 'API_ORIGIN';
export const HTML_ELEMENT = 'api-origin';
